import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowAccordion: Components<Theme>['MuiAccordion'] = {
  defaultProps: {
    // no space between open accordions
    disableGutters: true,
    // no rounded borders
    square: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      // remove default styling
      boxShadow: 'none',
      background: 'unset',
      // add borders
      borderLeft: 'none',
      borderRight: 'none',
      borderTop: `1px solid ${theme.palette.divider}`,
      borderBottom: `1px solid ${theme.palette.divider}`,
      // connect borders
      '& + .MuiAccordion-root': {
        marginTop: '-1px',
      },
      // get rid of default top border
      '&:before': {
        content: 'none',
      },
      // disabled state
      '&.Mui-disabled': {
        backgroundColor: 'unset',
      },
    }),
  },
};
